import { addDocumentUrlToMedia } from 'functions/addDocumentUrlToMedia';
import { addPosterUrlToMedia } from 'functions/addPosterUrlToMedia';
import { addUrlToMedia } from 'functions/addUrlToMedia';
import { addVideoUrlToMedia } from 'functions/addVideoUrlToMedia';

export const adaptMedia = (contentFields, path, language, defaultValue = '') => {
  const contentField = contentFields.find((contentField) => contentField.path === path);

  if (contentField?.mediaIdRaw?.length > 0 && contentField.mediaIdRaw[0]) {
    return {
      staticValue: adaptMediaByMediaType(getValueByLang(contentField, language, defaultValue)),
    };
  } else {
    return {
      staticValue: {
        id: null,
        url: defaultValue,
        name: defaultValue,
        width: 0,
        height: 0,
      },
    };
  }
};

const getValueByLang = (contentField, lang, defaultValue) => {
  if (!contentField.mediaIdRaw) return defaultValue;

  if (!contentField.mediaIdRaw[0]) return defaultValue;

  const availableLang = contentField.mediaIdRaw[0].value.map((v) => v.locale.toLowerCase());

  if (availableLang.includes(lang.toLowerCase())) {
    const translated = contentField.mediaIdRaw[0].value.find((v) => v.locale.toLowerCase() === lang.toLowerCase());
    return translated.media;
  }

  const defaultLocale = contentField.mediaIdRaw[0].defaultLocale;
  const translated = contentField.mediaIdRaw[0].value.find((v) => v.locale === defaultLocale);
  return translated.media;
};

const adaptMediaByMediaType = (media) => {
  switch (media['__typename']) {
    case 'Image':
      return {
        id: media.id,
        url: addUrlToMedia(media),
        name: media.path,
        width: media.width,
        height: media.height,
        isDark: media.isDark,
        type: media.__typename,
        fileExtension: media.path?.split('.').pop().toUpperCase(),
      };
    case 'Document':
      return {
        id: media.id,
        url: addDocumentUrlToMedia(media),
        name: media.path,
        type: media.__typename,
        fileExtension: media.path.split('.').reverse()[0],
        storageType: media.storageType,
      };
    case 'Video':
      return {
        id: media.id,
        url: addVideoUrlToMedia(media),
        poster: addPosterUrlToMedia(media),
        name: media.path,
        width: media.width,
        height: media.height,
        type: media.__typename,
      };
    default:
      return {
        type: 'UNKNOWN',
      };
  }
};
